// extracted by mini-css-extract-plugin
export default {"title":"ContactUs_title__-jxsz","description":"ContactUs_description__6cXGV"};